<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li class="active">打印机列表</li>
      </ol>
    </div>
    <div class="content-query content-border">
      <el-row>
        <el-col>
          <el-form :inline="true" :model="query" class="demo-form-inline" size="small">
            <el-form-item label="所属仓库">
              <el-select v-model="query.sellerId" placeholder="所属仓库" clearable>
                <el-option v-for="(item) in sellers" v-bind:key="item.id" :label="item.name" :value="item.id"/>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitQuery(1)" size="small" icon="el-icon-search">搜索</el-button>
              <el-button type="success" @click="$router.push({name:'printerDetail'});" size="small"
                         icon="el-icon-document-add">添加设备
              </el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <hr/>
    <div class="title">
      <span>打印机列表</span>
    </div>
    <el-table highlight-current-row :data="printers"
              @selection-change="handleSelectionChange">
      <el-table-column align="center" label="设备名称" prop="name"/>
      <el-table-column align="center" label="设备编号" prop="deviceCode"/>
      <el-table-column align="center" label="设备秘钥" prop="deviceKey"/>
      <el-table-column align="center" label="设备状态" prop="statusLabel">
        <template slot-scope="scope">
          <el-switch
              @change="savePrinterStatus({printer:scope.row})"
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="ENABLE"
              inactive-value="DISABLE"
              active-text="启用"
              inactive-text="禁用"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="250px">
        <template slot-scope="scope">
          <el-tooltip content="编辑设备" placement="top"
                      effect="light">
            <el-button type="primary"
                       @click="$common.goRouterLink({ name: 'printerDetail', query: { 'id': scope.row.id }})"
                       size="mini"
                       icon="el-icon-edit" round/>
          </el-tooltip>

          <printer-test :printer-id="scope.row.id" />

          <el-tooltip content="删除设备" placement="top"
                      effect="light">
            <el-button type="danger"
                       @click="del(scope.row.id)"
                       size="mini"
                       icon="el-icon-delete" round/>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <vue-pager v-bind:datafile="fillData" url="printer/pagePrinter" v-bind:query="query" ref="pager"
               v-bind:init="true"></vue-pager>
  </div>
</template>
<script>
import printerTest from './components/printer-test'
export default {
  components: {
    printerTest
  },
  data() {
    return {
      printers: [],
      query: {
        sellerId: ''
      },
      sellers: [],
      dynamicPath: config.dynamicResourcePath,

    }
  },
  created() {
    this.pageSeller();
  },
  methods: {
    savePrinterStatus(e) {
      let _this = this;
      _this.$common.my_ajax({
        url: 'printer/savePrinterStatus',
        data: {
          printerId: e.printer.id,
          status: e.printer.status
        },
        success: function () {
          this.submitQuery(this.query.current)
        }
      });
      console.log(e);
    },
    handleSelectionChange(val) {
      this.checkInputs = val;
    },
    fillData(response) {
      this.printers = response.items || [];
    },
    pageSeller() {
      this.$common.my_ajax({
        url: 'seller/pageSeller',
        data: {
          limit: -1,
        },
        success: (response) => {
          this.sellers = response.items;
        }
      });
    },
    submitQuery(_num) {
      this.$refs.pager.gotoPage(_num);
    },
    del(_id) {
      var _this = this;
      _this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$common.my_ajax({
          url: 'printer/deletePrinter',
          data: {
            printerId: _id
          },
          success: function () {
            // 刷新网点列表
            _this.$message({
              message: '删除成功',
              type: 'success',
              duration: 1000,
              onClose: function () {
                _this.submitQuery(1);
              }
            });
          }
        });
      })
    },
    test(_id) {
      let _this = this;
      _this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$common.my_ajax({
          url: 'printer/testPrinter',
          data: {
            printerId: _id
          },
          success: function () {
            _this.$message.success("执行成功")
          }
        });
      })
    }
  },
}
</script>
<style scoped>
.el-form-item {
  margin-bottom: 0;
}

.el-form-item--small.el-form-item {
  margin-bottom: 0;
}
</style>
